import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from "@angular/core";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { ModalAddNewContactComponent } from "../../../contact/component/addContact/modal-add-new-contact";
import { TalentPayrollService } from "../../../shared/services/talent-payroll.service";
import moment from "moment";
import { SubSink } from "subsink";

@Component({
    selector: "grid-filters",
    templateUrl: "./grid-filter.component.html",
    standalone: false
})
export class _GridFilterComponent implements OnInit, OnChanges {
    constructor(
        private talentPayrollService: TalentPayrollService,
        private _modalService: BsModalService,
        private _eventBusService: EventBusService,
        private _log: NbcLoggerService
    ) {}

    @Input() workFlowId: any = null;

    @Input() buAccess: any = {};

    @Input() departments: any = [];

    @Input() workStates: any = [];

    @Input() employeeTypes: any = [];

    subs = new SubSink();

    areValuesCalculated = false;
    payrollTimesheetListItems: any = [];
    queueStatus: any = [
        { id: "InQueue", description: "In-Queue" },
        { id: "PreQueue", description: "Pre-Queue" },
        { id: "PostQueue", description: "Post-Queue" },
    ];
    searchOptions: any = [
        { id: "ContactName", description: "Contact Name" },
        { id: "SSO", description: "SSO" },
        { id: "PerNer", description: "PerNer" },
    ];
    costCenterTypeValue: any = "";
    contactSearchValue: any = "";
    timecardsExportQuery: any = {};

    departmentFilterValues: any = [];
    costCenterType: any = "";
    contactSearchOption: any = null;

    queryContainer: any = {
        query: {},
    };

    uiValidators: any = {
        isQueueStatusEnabled: true,
        isWorkflowStatusEnabled: true,
    };

    processedDate: any;

    //getQuery() {
    //  let query:any = {};
    //  query.eventShowName = "";
    //  query.workState = "";
    //  query.employeeType = "";
    //  query.timecardDateFrom = "";
    //  query.timecardDateTo = "";
    //  query.processedDate = "";
    //  query.sso = "";
    //  query.perNer = "";
    //  query.CostCenter = "";
    //  query.contactName = "";
    //  query.currentPage = 1;
    //  query.workflowStatus = null;
    //  query.queueStatus = null;
    //  return query;
    //}

    getQuery() {
        const query = this.talentPayrollService.getPayrollTimesheetQuery(
            this.buAccess.businessUnitId,
            null,
            this.queryContainer.query.pageSize
                ? this.queryContainer.query.pageSize
                : null,
            null
        );
        return query;
    }

    defaultFilterValue() {
        this.queryContainer.query = this.getQuery();

        this.queryContainer.query.workflowStatus = this.workFlowId
            ? this.workFlowId
            : this.buAccess.departmentId;

        this.setQueueStatus();
        this.costCenterType = "WBSE";
        this.contactSearchValue = "";
        this.costCenterTypeValue = "";
        this.contactSearchOption = this.searchOptions[0].id;
        return this.queryContainer;
    }

    setQueueStatus() {
        if (this.workFlowId !== null && this.workFlowId > 0) {
            if (this.workFlowId === this.buAccess.departmentId) {
                this.queryContainer.query.queueStatus = this.queueStatus[0].id;
            } else if (
                this.workFlowId >= parseInt(this.buAccess.postQueue, 10)
            ) {
                this.queryContainer.query.queueStatus = this.queueStatus[2].id;
            } else if (
                this.workFlowId <= parseInt(this.buAccess.preQueue, 10)
            ) {
                this.queryContainer.query.queueStatus = this.queueStatus[1].id;
            } else {
                this.queryContainer.query.queueStatus = this.queueStatus[0].id;
            }
        } else {
            this.queryContainer.query.queueStatus = this.queueStatus[0].id;
        }
    }

    searchFilter() {
        if (
            this.queryContainer.query.timecardDateFrom != null &&
            this.queryContainer.query.timecardDateFrom != ""
        ) {
            this.queryContainer.query.timecardDateFrom = moment(
                this.queryContainer.query.timecardDateFrom
            ).format("MM/DD/YYYY");
        }

        if (
            this.queryContainer.query.timecardDateTo != null &&
            this.queryContainer.query.timecardDateTo != ""
        ) {
            this.queryContainer.query.timecardDateTo = moment(
                this.queryContainer.query.timecardDateTo
            ).format("MM/DD/YYYY");
        }

        if (
            this.queryContainer.query.processedDate != null &&
            this.queryContainer.query.processedDate != ""
        ) {
            this.queryContainer.query.processedDate = moment(
                this.queryContainer.query.processedDate
            )
                .startOf("day")
                .toDate();
        }
        this.queryContainer.query.currentPage = 1;
        this.search();
    }

    search() {
        if (this.contactSearchOption === "SSO") {
            this.queryContainer.query.sso = this.contactSearchValue;
            this.queryContainer.query.contactName = "";
            this.queryContainer.query.perNer = "";
        } else if (this.contactSearchOption === "PerNer") {
            this.queryContainer.query.perNer = this.contactSearchValue;
            this.queryContainer.query.contactName = "";
            this.queryContainer.query.sso = "";
        } else {
            this.queryContainer.query.contactName = this.contactSearchValue;
            this.queryContainer.query.sso = "";
            this.queryContainer.query.perNer = "";
        }

        if (this.costCenterType === "WBSE") {
            this.queryContainer.query.wbse = this.costCenterTypeValue;
            this.queryContainer.query.CostCenter = "";
        } else {
            this.queryContainer.query.CostCenter = this.costCenterTypeValue;
            this.queryContainer.query.wbse = "";
        }

        //After ProcessDate range changes in Report
        this.queryContainer.query.processedToDate =
            this.queryContainer?.query?.processedDate || "";

        this.queryContainer.query.workflowStatus =
            this.workFlowId == 5 &&
            this.queryContainer.query.workflowStatus == "4" &&
            this.queryContainer.query.isApproved &&
            this.queryContainer.query.queueStatus == "PostQueue"
                ? "5"
                : this.queryContainer.query.workflowStatus;
        {
            this.getTimecardsUsingQuery();
        }
    }

    resetSearch() {
        this.defaultFilterValue();
        this.queryContainer.query.timecardDateFrom = null;
        this.queryContainer.query.timecardDateTo = null;
        this.queryContainer.query.workflowStatus = this.workFlowId
            ? this.workFlowId.toString()
            : this.buAccess.departmentId.toString();
        this.queryContainer.query.queueStatus =
            this.workFlowId === 5 &&
            this.queryContainer.query.workflowStatus === "5" &&
            this.queryContainer.query.queueStatus === "PostQueue"
                ? "InQueue"
                : this.queryContainer.query.queueStatus;
        this.changeWorkFlowStatus();
        this.getTimecardsUsingQuery();
    }

    validateQueueState() {
        if (
            this.queryContainer.query.workflowStatus.toString() !==
                this.buAccess.departmentId.toString() ||
            (this.workFlowId !== null && this.workFlowId > 0)
        ) {
            this.uiValidators.isQueueStatusEnabled = false;
            //$("[name='queueStatus']").prop("disabled", true);
            //$("[name='queueStatus']").addClass("disabled");
            //$("[name='queueStatus']").val("InQueue");
            this.queryContainer.query.queueStatus = "InQueue";

            if (this.workFlowId !== null && this.workFlowId > 0) {
                if (this.workFlowId === this.buAccess.departmentId.toString()) {
                    //$("[name='queueStatus']").prop("disabled", false);
                    //$("[name='queueStatus']").removeClass("disabled");
                    //$("[name='queueStatus']").val("InQueue");
                    this.uiValidators.isQueueStatusEnabled = true;
                    this.queryContainer.query.queueStatus = "InQueue";
                } else {
                    this.uiValidators.isQueueStatusEnabled = false;
                    this.queryContainer.query.queueStatus = "InQueue";
                    //$("[name='queuestatus']").addclass("disabled");
                    //$("[name='queuestatus']").val("inqueue");
                }
            }
        } else {
            this.uiValidators.isQueueStatusEnabled = true;
            this.queryContainer.query.queueStatus = "InQueue";
            //$("[name='queueStatus']").prop("disabled", false);
            //$("[name='queueStatus']").removeClass("disabled");
            //$("[name='queueStatus']").val("InQueue");
            //this.queryContainer.query.queueStatus = "InQueue";
        }
    }

    changeWorkFlowStatus() {
        if (
            this.queryContainer.query.workflowStatus.toString() !==
                this.buAccess.departmentId.toString() ||
            (this.workFlowId !== null && this.workFlowId > 0)
        ) {
            this.uiValidators.isQueueStatusEnabled = false;
            //$("[name='queueStatus']").prop("disabled", true);
            //$("[name='queueStatus']").addClass("disabled");
            //$("[name='queueStatus']").val("InQueue");
            this.queryContainer.query.queueStatus = "InQueue";

            if (this.workFlowId !== null && this.workFlowId > 0) {
                if (
                    parseInt(this.queryContainer.query.workflowStatus, 10) ===
                    this.buAccess.departmentId
                ) {
                    this.uiValidators.isQueueStatusEnabled = true;
                    //$("[name='queueStatus']").prop("disabled", false);
                    //$("[name='queueStatus']").removeClass("disabled");
                    //$("[name='queueStatus']").val("InQueue");
                    this.queryContainer.query.queueStatus = "InQueue";
                } else {
                    this.uiValidators.isQueueStatusEnabled = false;
                    // $("[name='queueStatus']").addClass("disabled");
                    //$("[name='queueStatus']").val("InQueue");
                }
            }
            this.validateWorkflowStatus();
        } else {
            this.uiValidators.isQueueStatusEnabled = true;
            //$("[name='queueStatus']").prop("disabled", false);
            //$("[name='queueStatus']").removeClass("disabled");
            //$("[name='queueStatus']").val("InQueue");
            this.queryContainer.query.queueStatus = "InQueue";
            this.validateWorkflowStatus();
        }
    }

    validateWorkflowStatus() {
        if (this.queryContainer.query.queueStatus !== this.queueStatus[0].id) {
            this.uiValidators.isWorkflowStatusEnabled = false;
            //$("[name='workflowStatus']").attr("disabled", "disabled");
            //$("[name='workflowStatus']").addClass("disabled");
        } else {
            this.uiValidators.isWorkflowStatusEnabled = true;
            //$("[name='workflowStatus']").removeAttr("disabled");
            //$("[name='workflowStatus']").removeClass("disabled");
        }
        if (this.queryContainer.query.queueStatus !== this.queueStatus[2].id) {
            // $("[name='ProcessedDate']").value = null;
            this.queryContainer.query.processedDate = "";
        }
    }

    getDepartmentFilterValues() {
        _.forEach(this.departments, (department) => {
            this.departmentFilterValues.push(department.department);
        });
    }

    getTimecardsUsingQuery() {
        this._eventBusService.emit(
            new EmitEvent(
                "filter:search",
                "onFilterTimecards",
                this.queryContainer
            )
        );
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === "buAccess") {
                const current = changes["buAccess"]["currentValue"];
                const prev = changes["buAccess"]["previousValue"];
                this.buAccess = current;
                this.init();
            }
            if (propName === "departments") {
                const current = changes["departments"]["currentValue"];
                const prev = changes["departments"]["previousValue"];
                this.departments = current;
                this.getDepartmentFilterValues();
                this.init();
            }
            if (propName === "employeeTypes") {
                const current = changes["employeeTypes"]["currentValue"];
                const prev = changes["employeeTypes"]["previousValue"];
                this.employeeTypes = current;
                this.employeeTypes = _.orderBy(
                    this.employeeTypes,
                    ["description"],
                    ["asc"]
                );
            }
            if (propName === "workflowId") {
                const current = changes["workflowId"]["currentValue"];
                const prev = changes["workflowId"]["previousValue"];
                this.workFlowId = current;
                this.init();
            }
        }
    }

    openAddContactModal() {
        let bsModalRef: BsModalRef;
        const initialState: any = {
            // userBuAccess: this.selectedBuAccess,
            businessUnitId: this.buAccess.departmentId.businessUnitId,
            departmentId: this.buAccess.departmentId.departmentId,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };
        bsModalRef = this._modalService.show(
            ModalAddNewContactComponent,
            modalOptions
        );
    }

    subscribeEventHandlers() {
        this.subs.sink = this._eventBusService.on(
            "setCurrentPageSize",
            (data) => (this.queryContainer.query.pageSize = data)
        );
        this.subs.sink = this._eventBusService.on(
            "setSortByCol",
            (data) => (this.queryContainer.query.sortByColumn = data)
        );
        this.subs.sink = this._eventBusService.on(
            "setReverseSort",
            (data) => (this.queryContainer.query.reverseSort = data)
        );
    }

    init() {
        this.subscribeEventHandlers();
        this.queryContainer = this.defaultFilterValue();
        setTimeout(() => (this.areValuesCalculated = true), 500);
    }
    ngOnInit() {
        this.init();
        this.validateQueueState();
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
